// UPS Invoiced by ShipStation (provider 4790) resells UPS, so these mirror UpsWalletService
// but carry their own ShippingServiceIDs.
export const UpsInvoicedService = Object.freeze({
  Ground: '479007',
  GroundSaver: '479011',
  ThreeDaySelect: '479006',
  NextDayAirSaver: '479003',
  NextDayAir: '479002',
  SecondDayAir: '479004',
});
